import { SECTIONS } from '@/constants'

export const searchApps = (items, query) => {
  if (!query) return items

  const normalizedQuery = query.toLowerCase()

  return query
    ? items.filter(
        ({ name, slug, shortDescription, longDescription, category }) => {
          const normalizedName = name.toLowerCase()
          const normalizedSlug = slug.toLowerCase()
          const normalizedShortDescription =
            shortDescription?.toLowerCase() || ''
          const normalizedLongDescription = longDescription?.toLowerCase() || ''
          const normalizedCategory = category?.name.toLowerCase() || ''

          return (
            normalizedName.includes(normalizedQuery) ||
            normalizedSlug.includes(normalizedQuery) ||
            normalizedShortDescription.includes(normalizedQuery) ||
            normalizedLongDescription.includes(normalizedQuery) ||
            normalizedCategory?.includes(normalizedQuery)
          )
        }
      )
    : []
}

export const searchExperts = (items, query) => {
  if (!query) return items

  const normalizedQuery = query.toLowerCase()

  return query
    ? items.filter(({ name, slug, company }) => {
        const normalizedName = name.toLowerCase()
        const normalizedSlug = slug.toLowerCase()
        const normalizedCompany = company.toLowerCase()

        return (
          normalizedName.includes(normalizedQuery) ||
          normalizedSlug.includes(normalizedQuery) ||
          normalizedCompany.includes(normalizedQuery)
        )
      })
    : []
}

export const getSearchFunction = (section) => {
  switch (section) {
    case SECTIONS.APPS:
      return searchApps
    case SECTIONS.EXPERTS:
      return searchExperts
    default:
      return null
  }
}
